export const GENERIC_ERROR = "No pudimos completar la operación. Intentá nuevamente. Si el problema continúa, contactá al equipo de soporte.";

// Conserva primero el mensaje de validación del servidor, incluso en respuestas HTTP 500.
export function errorMessage(error) {
  const errors = error?.graphQLErrors?.length ? error.graphQLErrors
    : error?.networkError?.result?.errors || error?.response?.data?.errors || error?.result?.errors;
  if (errors?.length) {
    const messages = [...new Set(errors.map(errorMessage))];
    return messages.filter((message) => message !== GENERIC_ERROR).join(" ") || GENERIC_ERROR;
  }
  const message = String(typeof error === "string" ? error : error?.response?.data?.error || error?.message || "")
    .replace(/^(?:ApolloError:|Error:|GraphQL error:)\s*/i, "").trim();
  if (/jwt expired|token expired|unauthenticated|sesión.*expir|sesion.*expir/i.test(message))
    return "Tu sesión venció. Iniciá sesión nuevamente para continuar.";
  if (/unauthorized|not authenticated|authentication required/i.test(message))
    return "Iniciá sesión para realizar esta operación.";
  if (/forbidden|access denied|permission denied/i.test(message))
    return "No tenés permiso para realizar esta operación.";
  if (/status code 401/i.test(message)) return "Tu sesión venció. Iniciá sesión nuevamente para continuar.";
  if (/status code 403/i.test(message)) return "No tenés permiso para realizar esta operación.";
  if (/failed to fetch|network error|networkerror|ECONNREFUSED|ERR_NETWORK|load failed/i.test(message))
    return "No pudimos conectar con el servidor. Revisá tu conexión e intentá nuevamente.";
  if (/timeout|timed out/i.test(message))
    return "La operación demoró más de lo esperado. Intentá nuevamente.";
  if (/too large|maxFileSize|file size|status code 413/i.test(message))
    return "El archivo supera el tamaño permitido. Seleccioná uno más pequeño.";
  if (/Sequelize|SQL|constraint|Cannot |undefined|null|stack|GraphQL error:|ApolloError|Response not successful|status code|Request failed|Unexpected |SyntaxError|TypeError|Internal server|ENOENT|EACCES|Validation error/i.test(message))
    return GENERIC_ERROR;
  // Solo publica mensajes reconocibles en español; cualquier error técnico desconocido usa el respaldo.
  return /[áéíóúñ¿¡]|\b(no|el|la|los|las|un|una|debe|complete|completá|indique|seleccione|error al|inválido|invalido|obligatorio|permiso|datos|cargue|adjunte|ya|falta)\b/i.test(message)
    ? message : GENERIC_ERROR;
}
